import { IGroupHealthInsuranceIndividualsInitialValues } from '../../../../../types';

export const INITIAL_VALUES: IGroupHealthInsuranceIndividualsInitialValues = {
  id: undefined,
  upload_files: [],
  email_users: [],
  branch: '',
  start_date: '',
  end_date: '',
  description: '',
  first_name: '',
  last_name: '',
  turkish_id: '',
  birthday: '',
  organization: 0,
  recent_status: '',
  date_of_employment: '',
  date_of_termination: '',
  gender: '',
  gsm: '',
};
